import { httpsCallable } from 'firebase/functions';
import { ref as storageRef, getDownloadURL } from 'firebase/storage';
import { functions, storage } from '../../firebase';

export const call = async (name, data) => (await httpsCallable(functions, name, { timeout: 300000 })(data)).data;

export const KINDS = [['nda', 'NDA'], ['agreement', 'Agreement'], ['dpa', 'Data processing'], ['terms', 'Terms'], ['other', 'Other']];
export const KIND_LABEL = Object.fromEntries([...KINDS, ['plan', 'Build plan']]);
export const PACK_STATUS = {
  draft: ['Draft', 'none'], sent: ['Sent', 'warn'], signing: ['Signing', 'info'], signed: ['Signed', 'good'],
  awaiting_payment: ['Awaiting payment', 'warn'], payment_pending: ['Payment pending', 'info'], paid: ['Paid', 'good'], void: ['Void', 'bad'],
};
export const PARTY_FIELDS = [
  ['legalName', 'Legal name'], ['tradingName', 'Trading name'], ['companyNumber', 'Company number'], ['registry', 'Registry'],
  ['registeredAddress', 'Registered address'], ['signerName', 'Signer name'], ['signerRole', 'Signer role'], ['signerEmail', 'Signer email'],
];
export const REGISTRIES = ['Companies House (UK)', 'CRO (Ireland)', 'Other'];

const TONE = {
  good: ['var(--color-success)', 'var(--color-success-light)'], warn: ['var(--color-warning)', 'var(--color-warning-light)'],
  info: ['var(--color-info)', 'var(--color-info-light)'], bad: ['var(--color-danger)', 'var(--color-danger-light)'],
  none: ['var(--color-text-tertiary)', 'var(--color-bg-tertiary)'],
};
export function Chip({ label, tone = 'none' }) {
  const [c, bg] = TONE[tone];
  return <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 'var(--radius-full)', background: bg, color: c, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>{label}</span>;
}

export const fmt = (ts) => (ts?.toDate ? ts.toDate().toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const money = (minor, cur) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: (cur || 'gbp').toUpperCase() }).format(minor / 100);

export async function openStoragePdf(path) {
  const w = window.open('', '_blank');
  try { w.location.href = await getDownloadURL(storageRef(storage, path)); } catch (e) { w?.close(); throw e; }
}

export function openBase64Pdf(b64) {
  const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const banner = (tone) => ({ padding: '8px 12px', background: `var(--color-${tone}-light)`, color: `var(--color-${tone})`, borderRadius: 'var(--radius-md)', fontSize: 12 });
